import styled from 'styled-components'

import { media } from '@/theme/common'

// Note: TableGroup sizes every direct filter child to 16rem - the triple && outranks that rule so
// the buildings select can be 50% wider (24rem) without an inline width, keeping full width on mobile
export const BuildingFilter = styled.div`
  &&& {
    width: 24rem;

    ${media.down('sm')} {
      width: 100%;
    }
  }
`
